module.exports = __webpack_public_path__ + "static/limit-subcategories-in-mega-menu-a12a6a4c2ab62b7298601f2a5c73d332.png";